import React from 'react';
import './Requirements.css';

function Requirements() {
  const flowSteps = [
    'Register as a Manufacturer / Distributor with the appropriate package.',
    'Invite your dealers to complete their credit application online.',
    'Dealers place orders using their approved credit limit',
    'The order amount is instantly transferred to your bank account.',
    'Dealers repay us within the credit period (up to 60 days).'
  ];

  const expectSteps = [
    'Instant 5-minute credit for your dealers.',
    'Immediate Settlement/payment to you.',
    'Up-to 60 Days of credit for dealers.',
    'Interest charged only for days the credit is utilized.'
  ];

  return (
    <section className="requirements">
      <div className="requirements-container">
        <div className="requirements-content">
          <h2 className="heading-lg">Credit Order Flow</h2>
          <div className="card-content">
            {flowSteps.map((step, index) => (
              <div key={index} className="step-item">
                <div className="step-icon">
                  <span className="step-number">{index + 1}</span>
                </div>
                <span className="step-text">{step}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="timeline-content">
          <h2 className="heading-lg">What to Expect ?</h2>
          <div className="card-content">
            {expectSteps.map((step, index) => (
              <div key={index} className="step-item">
                <div className="step-icon green-icon">
                  <span className="checkmark">✓</span>
                </div>
                <span className="step-text">{step}</span>
              </div>
            ))}
            <p className="caption-sm timeline-note">
              Note: Application submitted after 5PM IST will be processed the following business day. Weekend submissions begin processing on Monday.
            </p>
          </div>
        </div>
      </div>
      <div className="bottom-text">
        <h3 className="green-text">100% Digital Process | Credit Up-to 25 Lakhs</h3>
      </div>
    </section>
  );
}

export default Requirements;